<template>
  <div class="image-upload-type-4">
    <div class="container">
      <div
        id="fileBox"
        class="file-box"
        :class="{ 'before-file-upload': previewNames.length <= 0 }"
      >
        <label class="input-click-box" for="files">
          <input
            type="file"
            ref="fileInput"
            id="files"
            class="files"
            :multiple="limitedFileUploadCount > 1 ? true : false"
            :accept="acceptType"
            @change="fileChange"
          />
        </label>
      </div>
      <div class="preview">
        <div class="image" v-for="(item, index) in previewImages" :key="index">
          <img
            @click="removeImage(index)"
            class="remove-button"
            src="../../assets/images/photographer/remove_button.svg"
          />
          <img v-imageServiceLoading="item.fullPath" />
        </div>
      </div>
      <div @click="clickAddFile" class="file-select-button">UPLOAD</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { defaultStore, firebaseConnection } from '@/library/firebase'
import mixCommon from '@/mixin/common'

const Hash = require('object-hash')

export default {
  mixins: [mixCommon],
  name: 'image-upload-type-4',
  props: {
    limitedFileUploadCount: {
      default: 6,
      type: Number
    },
    acceptType: {
      default: 'image/*',
      type: String
    },
    message: {
      default: '클릭 또는 드래그하여 이미지를 올려주세요.',
      type: String
    },
    size: {
      default: 200,
      type: Number
    },
    standard: {
      default: 'width',
      type: String
    },

    directory: {
      default: 'images',
      type: String
    },
    importPreviewImages: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      files: '',
      acceptLists: {
        image: 'image/*',
        excel: ''
      },
      tempSize: this.size,
      previewNames: [],
      previewImages: [],
      previewsProgress: [],
      uploadedImagesId: [], // 이미지 삭제하기 위해서 필요
      previewNotLoadImage: require('@/assets/images/bottom_logo.svg'),
      result: {
        originals: []
      },
      tempMessage: this.message,
      uniqueFileNumber: 0,
      returnSavedImages: [],
      selectedMainSaveImage: 0, // 인덱스 값
      tempImportPreviewImages: {}
    }
  },
  created() {
    // console.log(this.importPreviewImages)
  },
  mounted() {
    this.files = this.$refs.fileInput
    document.addEventListener('dragover', this.dragOverHandler)
    document.addEventListener('drop', this.dragDropHandler)
    document.addEventListener('dragleave', this.dragDropLeave)
    // this.clickAddFile()
  },
  destroyed() {
    document.removeEventListener('dragover', this.dragOverHandler)
    document.removeEventListener('drop', this.dragDropHandler)
    document.removeEventListener('dragleave', this.dragDropLeave)
  },
  updated() {},
  methods: {
    clickAddFile() {
      this.files.click()
    },
    dragOverHandler(e) {
      e.stopPropagation()
      e.preventDefault()
      // console.log('image drag sensor', e.buttons)
      // e.dataTransfer.dropEffect = 'move'
      if (e.buttons === 0) {
        this.tempMessage = '이미지를 드롭하세요.'
      }
    },
    dragDropHandler(e) {
      e.stopPropagation()
      e.preventDefault()
      const data = e.dataTransfer
      const files = data.files

      // console.log(`File Count: ${count}`)
      this.fileProcess(files, 0)
      this.tempMessage = '클릭 또는 이미지를 드래그 해주세요.'
    },
    dragDropLeave() {
      this.tempMessage = '클릭 또는 이미지를 드래그 해주세요.'
    },
    bindDeleteImage() {
      //  TODO: 비동기로 이미지 추가 하기
      // const images = document.querySelectorAll('.item')
      // images.forEach((element) => {
      // console.log('elements:', element)
      // element.addEventListener('click', console.log('el'))
      // const target = getComputedStyle(element, ':before')
      // console.log(target)
      // target.addEventListener('click', console.log('ddd'))
      // })
    },
    // Recursion Function
    fileProcess(files, i) {
      // console.log('this.limitedFileUploadCount:', this.uniqueFileNumber, this.limitedFileUploadCount, files.length)
      // 조건
      // image 가  null 로 되어 있으면, 순서대로 저장한다.
      // 만약 선택한 이미지가 있는경우 선택한 이미지만 저장한다. (선택한 이미지중 이미 있는 경우에는 업데이트를 한다.)

      if (files && this.uniqueFileNumber < this.limitedFileUploadCount) {
        const file = files[i]
        // console.log(file)
        this.filePreview(file).then(result => {
          // console.log('file preview: ', result)
          if (result) {
            i++ // increase array key value
            this.fileProcess(files, i)
          } else {
            console.log('Finish the Image files add.')
          }
        })
      } else {
        console.log('업로드 끝')
      }
    },
    fileChange(e) {
      // 여기에서 셀렉트 인지 아닌지 체크
      //여기에서 이미지로 저장할 데이터들의 값을 배열로 만들어서 취합한다.
      this.fileProcess(e.target.files, 0)
    },
    fileAdd(file) {
      return new Promise((resolve, reject) => {
        const files = new FileReader()
        let progressPercentage = 0

        files.addEventListener('loadstart', () => {
          // 이미지가 업로드 중이면, 계속 인터벌을 돌면서 업로드 진행 상태를 가시적으로 보여준다. (즉 업로드 상태 피싱)
          this.$set(this.previewImages, this.uniqueFileNumber, {
            id: null,
            url: this.previewNotLoadImage
          })
          this.previewsProgress.push(0)
          this.previewNames.push(file.name)
          const progress = setInterval(() => {
            progressPercentage += 1
            if (progressPercentage <= 100) {
              this.previewsProgress[this.uniqueFileNumber] = progressPercentage
            } else {
              clearInterval(progress)
            }
          }, 100)
        })

        files.addEventListener('load', () => {
          const image = new Image()
          image.onload = () => {
            setTimeout(() => {
              return this.fileUpload(file, image)
                .then(res => {
                  // 프리뷰를 위해서 미리 더비데이터 업로드
                  this.$set(this.previewImages, this.uniqueFileNumber, {
                    id: null
                  })
                  return res
                })
                .then(result => {
                  if (result) {
                    // 리미지 리사이징 만들기
                    return new Promise(resolve => {
                      console.log('upload:', result)
                      this.$set(this.previewImages, this.uniqueFileNumber, {
                        id: null,
                        fullPath: result.metadata.fullPath
                      }) // 미리보기 이미지
                      this.$set(
                        this.previewsProgress,
                        this.uniqueFileNumber,
                        100
                      ) // 업로드 상태 완료
                      progressPercentage = 100
                      resolve(true)
                    }).then(result => {
                      setTimeout(() => {
                        // 스토어에 저장
                        this.uniqueFileNumber++
                        resolve(result)
                      }, 0)
                    })
                  } else {
                    console.log('이미지 업로드 실패')
                    resolve(false)
                  }
                })
            }, 0)
          }
          image.src = files.result
        })

        files.addEventListener('progress', e => {
          console.log('progress', e)
        })

        files.readAsDataURL(file)

        files.onabort = () => {
          reject('error')
          console.error('The upload was aborted.')
        }

        files.onerror = () => {
          reject('error')
          console.error('An error occured while reading the file.')
        }
      })
    },
    async filePreview(file) {
      if (typeof file !== 'undefined') {
        if (/\.(jpe?g|png)$/i.test(file.name)) {
          return await this.fileAdd(file)
        } else {
          console.log('이미지 중복이거나, 이미지가 아닌 파일')
          return new Promise(resolve => resolve(true))
        }
      } else {
        console.log('이미지 중복이거나, 이미지가 아닌 파일')
        return new Promise(resolve => resolve(false))
      }
    },
    async fileUpload(file, image) {
      console.log('image metadata info:', image.width)
      const direction = image.width > image.height ? 'width' : 'height'
      // let formData = new FormData()
      // formData.append('file', file) 일반 request http 업로드 할땐 필요함
      const fileName = Hash(new Date().getTime() + file.name)
      console.log('firebase :', firebaseConnection)
      return await firebaseConnection
        .storage()
        .ref()
        .child(this.directory)
        .child(this.$store.getters.userInfo.uid)
        .child(fileName)
        .put(file)
        .then(res => {
          // 이미지 관리를 위해서 이미지만 따로 저장
          console.log('Main upload: ', res)
          const obj1 = Object.assign(
            {},
            {
              uid: this.$store.getters.userInfo.uid,
              status: true,
              direction: direction
            },
            res.metadata
          )
          delete obj1.cacheControl
          delete obj1.contentLanguage
          delete obj1.customMetadata
          return defaultStore
            .collection('images')
            .add(obj1)
            .then(doc => {
              // console.log('image saved', doc)
              this.uploadedImagesId.push(doc.id)

              return this.thumbnail(image, fileName).then(thumb => {
                console.log('thumbnail: ', thumb)
                this.returnSavedImages.push({
                  direction: direction,
                  imageUid: doc.id,
                  fileName: fileName,
                  mainFullPath: res.metadata.fullPath,
                  thumbnailFullPath: thumb.metadata.fullPath
                })

                this.$emit('model', this.returnSavedImages)
                return thumb
              })
            })
        })
    },
    async thumbnail(image, fileName) {
      this.tempSize = 300
      const convertImage = await this.reSize(image)
      return new Promise(resolve => {
        this.tempSize = this.size
        firebaseConnection
          .storage()
          .ref()
          .child(this.directory)
          .child(this.$store.getters.userInfo.uid)
          .child('thumbnail')
          .child(fileName)
          .putString(convertImage, 'data_url')
          .then(res => {
            resolve(res)
          })
      })
    },
    reSize(image) {
      return new Promise(resolve => {
        const canvas = document.createElement('canvas')
        if (this.standard === 'width') {
          if (image.width > this.tempSize) {
            image.height *= this.tempSize / image.width
            image.width = this.tempSize
          }
        } else {
          if (image.height > this.tempSize) {
            image.width *= this.tempSize / image.height
            image.height = this.tempSize
          }
        }
        const ctx = canvas.getContext('2d')
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        canvas.width = image.width
        canvas.height = image.height
        ctx.drawImage(image, 0, 0, image.width, image.height)
        resolve(canvas.toDataURL('image/png'))
      })
    },
    removeImage(index) {
      // 기존 방식
      // console.log('index:', index)
      // 파이어베이스에서는 웹에서 삭제를 권고 하지 않는다. 그래서 파일만 지우고 레코드를 삭제 하지 못하기 때문에
      // 우선 삭제는 하지 않는걸로~
      if (index < this.previewImages.length) {
        defaultStore
          .collection('images')
          .doc(this.uploadedImagesId[index])
          .update({
            status: false
          })
          .then(() => {
            // console.log('updated file', res)
            this.uniqueFileNumber--
            this.previewNames.splice(index, 1)
            this.previewImages.splice(index, 1)
            this.previewsProgress.splice(index, 1)
            this.files.value = null
            this.returnSavedImages.splice(index, 1)
            this.uploadedImagesId.splice(index, 1)
            this.$emit('model', this.returnSavedImages)
          })
      }
    },
    setImportPreviews() {
      this.uniqueFileNumber = this.tempImportPreviewImages.length
      this.tempImportPreviewImages.forEach(v => {
        this.previewNames.push(v.filename)
        this.previewImages.push({
          id: v.imageUid,
          fullPath: v.thumbnailFullPath
        })
        this.previewsProgress.push(100)
        this.returnSavedImages.push(v)
        this.uploadedImagesId.push(v.imageUid)
      })
      // this.$forceUpdate()
    },
    randomIndex() {
      return Math.floor(Math.random() * 100)
    }
  },
  watch: {
    importPreviewImages: function(val) {
      this.tempImportPreviewImages = val
      // console.log('watch: ',val)
      this.setImportPreviews()
    }
  },
  computed: {
    ...mapState(['sections'])
  }
}
</script>

<style lang="scss" scoped>
.image-upload-type-4 {
  .container {
    width: 100%;
    height: 228px;
    background-color: #f5f5f5;
    border: solid 1px #e7e7e7;
    position: relative;

    .preview {
      top: 0;
      bottom: 0;
      margin: auto 0;
      left: 20px;
      position: absolute;
      height: 200px;
      display: flex;
      justify-content: stretch;
      align-items: center;

      .image {
        position: relative;
        margin: 0 10px 0 0;
        width: 123px;
        height: 184px;
        display: flex;
        overflow: hidden;
        justify-content: center;
        align-items: center;

        .remove-button {
          cursor: pointer;
          position: absolute;
          top: 0;
          right: 0;
          width: 40px;
          height: 40px;
        }

        img {
          width: 100%;
          object-fit: cover;
        }
      }
    }

    .file-box {
      z-index: 0;
      position: relative;
      width: inherit;
      height: inherit;
      display: block;

      .input-click-box {
        position: absolute;
        width: inherit;
        height: inherit;
      }

      .files {
        opacity: 0;
      }
    }

    .before-file-upload {
      z-index: 30;
    }

    .file-select-button {
      color: #000;
      width: 150px;
      height: 50px;
      font-size: 14px;
      font-weight: 300;
      background-color: white;
      border: 1px solid #c8c8c8;
      position: absolute;
      right: 10px;
      bottom: 10px;
      z-index: 100;
      cursor: pointer;
      text-align: center;
      line-height: 50px;
    }
  }
}
</style>
